module.exports = __webpack_public_path__ + "img/aside-pyramid-mobile.cec088df.png";